<template>
  <vue-input v-mask="'######-####'" v-bind="$attrs" v-on="$listerners" ref="input" />
</template>

<script>
import VueInput from '@/components/vue-components/vue-input/VueInput.vue';

export default {
    name: 'PersonalIdentityNumberInput',
    inheritAttrs: false,
    components: {
        VueInput
    },
    methods: {
        getValue() {
            return this.$refs.input.getValue();
        }
    }
}
</script>

<style>

</style>